export default function(_) {
  return typeof _ === 'boolean';
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/isBoolean.js
// module id = 1538
// module chunks = 0